<template>
  <div>
    <div
      class="homework-card white rounded-5"
      :class="
        account_type === 'school' ||
        account_type === 'parent' ||
        account_type === 'student' ||
        (account_type === 'teacher' && tab !== 'Draft')
          ? 'pointer'
          : null
      "
      @click="handleCardClickActions($event)"
    >
      <div class="d-flex justify-content-between align-items-center nowrap">
        <!-- HOMEWORK INFO -->
        <div class="left">
          <div
            class="d-flex justify-content-start align-items-center nowrap homework-info"
          >
            <!-- AVATAR -->
            <div class="avatar avatar-square avatar_sm_md">
              <div class="avatar-with-meta brand_inverse_light_bg">
                <div class="avatar-title brand_navy">{{ day }}</div>
                <div class="avatar-meta color_text">{{ month }}</div>
              </div>
            </div>

            <!-- HOMEWORK DETAIL -->
            <div class="details">
              <div class="title brand_navy font-weight-bold text-capitalize">
                <div v-if="tab != 'Draft'">{{ title }}</div>
                <router-link
                  @click.native="
                    Number(total_questions) > 0
                      ? $emit('view-questions')
                      : $emit('attach-questions')
                  "
                  to
                  v-else
                  >{{ title }}</router-link
                >
              </div>
              <div class="meta color_grey_dark">
                {{ subject }} &nbsp;
                <span
                  v-if="tag"
                  class="font-11-5 border_grey_dark text-capitalize"
                  >({{ tag }})</span
                >
                &nbsp;
                <span
                  class="font-weight-bold text-uppercase status"
                  :class="status_color"
                  v-if="
                    (account_type === 'school' || account_type === 'teacher') &&
                      tab != 'Draft'
                  "
                  >&nbsp;•&nbsp; {{ getStatus }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <div
          class="right d-flex justify-content-between align-items-center nowrap"
        >
          <!-- SET EMPTY DIV -->
          <div
            v-if="account_type === 'parent' || account_type === 'student'"
          ></div>
          <!-- OTHERS -->
          <div v-else>
            <template v-if="tab != 'Draft'">
              <div
                class="d-flex justify-content-start align-items-center progress-container"
                :title="studentCount"
              >
                <template v-if="submitted_students > 0">
                  <div class="progress">
                    <div
                      class="progress-bar brand_accent_bg"
                      :style="'width:' + getSubmittedStudents + '%'"
                      role="progressbar"
                    ></div>
                  </div>
                  <div class="icon-members color_grey_dark font-19 ml-1"></div>
                  <div class="submitted_count color_grey_dark">
                    {{ submitted_students }}
                  </div>
                </template>

                <template v-else>
                  <div class="progress">
                    <div
                      class="progress-bar brans_green_light_bg"
                      :style="'width:' + getSubmittedStudents + '%'"
                      role="progressbar"
                    ></div>
                  </div>
                  <div class="icon-members color_grey_dark font-19 ml-1"></div>
                  <div class="submitted_count color_grey_dark">
                    {{ submitted_students }}
                  </div>
                </template>
              </div>
            </template>

            <div
              class="color_grey_dark font-13-5 text-left d-flex justify-content-start align-items-center"
              v-if="tab == 'Draft'"
            >
              <span class="d-none d-md-block">Not Published</span>
            </div>
          </div>
          <!-- OPTION -->
          <div class="option position-relative">
            <div
              class="pointer"
              v-if="account_type === 'parent' || account_type === 'student'"
            >
              <template v-if="subscription_status === true">
                <span
                  @click="toggleSwitchModal"
                  v-if="account_type === 'parent'"
                  class="font-weight-bold font-14 link-no-underline btn-link d-none d-sm-block starter-btn"
                  >Attempt</span
                >
                <span
                  @click="toggleHomeworkModal"
                  v-if="account_type === 'student' && tag === 'quiz'"
                  class="font-weight-bold font-14 link-no-underline btn-link d-none d-sm-block starter-btn"
                  >Start Quiz</span
                >
                <span
                  @click="toggleHomeworkModal"
                  v-if="
                    account_type === 'student' &&
                      (tag === 'homework' || tag == null)
                  "
                  class="font-weight-bold font-14 link-no-underline btn-link d-none d-sm-block starter-btn"
                  >Start Homework</span
                >

                <button
                  @click="toInstructionPage"
                  style="background:transparent"
                  v-if="account_type === 'student' && tag === 'exam'"
                >
                  <span
                    class="font-weight-bold font-14 link-no-underline btn-link d-none d-sm-block starter-btn"
                    >Start Exam</span
                  >
                </button>
                <!-- MOBILE VIEW -->
                <span
                  class="icon-caret-right border_grey_dark font-14 link-no-underline d-sm-none"
                ></span>
              </template>

              <template v-else>
                <span
                  class="d-flex justify-content-end align-items-center font-weight-bold brand_tonic locked"
                >
                  <span class="icon-lock-fill font-12 mr-1"></span>
                  <span class="font-14-5 ml-1">Locked</span>
                </span>
              </template>
            </div>

            <div to v-else>
              <div
                class="avatar"
                v-on-clickaway="dropOption"
                @click="toggleHomeworkOption"
                v-if="tag !== 'exam' || !review_status"
              >
                <span
                  class="icon-ellipsis-h color_grey_dark font-20 flex-center"
                ></span>
              </div>

              <!-- DROPDOWN MENU -->
              <div
                class="dropdown-btn-menu placement-bottom ignore"
                v-if="homework_option"
              >
                <ul class="list-unstyled ignore">
                  <li v-if="tab !== 'Draft'" class="ignore d-none">
                    <router-link
                      :to="{ name: route_name, params: { homework_id: id } }"
                      >View Report</router-link
                    >
                  </li>
                  <li
                    v-if="tab === 'Draft' || tab === 'Review'"
                    class="ignore"
                    @click="
                      Number(total_questions) > 0
                        ? $emit('view-questions')
                        : $emit('attach-questions')
                    "
                  >
                    <router-link to class="ignore">
                      {{
                        Number(total_questions) > 0
                          ? "Manage Questions"
                          : "Add Questions"
                      }}
                    </router-link>
                  </li>

                  <li
                    class="ignore"
                    v-if="account_type === 'teacher'"
                    @click="$emit('update-homework')"
                  >
                    <router-link to>Edit Assessment</router-link>
                  </li>
                  <li
                    class="ignore"
                    @click="$emit('manage-dates')"
                    v-if="getStatus !== 'rejected'"
                  >
                    <router-link to>Manage Dates</router-link>
                  </li>
                  <li
                    class="ignore"
                    @click="$emit('restart-homework')"
                    v-if="tab !== 'Draft' && getStatus !== 'rejected'"
                  >
                    <router-link to>Restart Assessment</router-link>
                  </li>
                  <li class="ignore" @click="$emit('delete-homework')">
                    <router-link to>Delete Assessment</router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL -->
    <StartHomeworkModal
      v-if="homework_modal"
      :tag="tag"
      :proctor="proctor"
      :homework_data="homework_data"
      @toggleProctor="toggleExamModal($event)"
      @closeTriggered="toggleHomeworkModal"
    ></StartHomeworkModal>

    <SwitchAccountModal
      v-if="switch_modal"
      @closeTriggered="toggleSwitchModal"
    />

    <StartExamModal
      v-if="exam_modal"
      :tag="tag"
      :proctor="proctor"
      :exam_id="exam_id"
      @closeTriggered="toggleExamModal"
    />
    <!-- MODAL -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mixin as clickaway } from "vue-clickaway";
import monthsFormat from "@/scripts/mixins/monthsFormat";
import { random } from "@/scripts/utilities";

export default {
  name: "HomeworkCard",

  props: {
    id: Number,
    date: String,
    title: String,
    submitted_students: Number,
    expected_students: Number,
    class_id: Number,
    class_name: String,
    subject: String,
    status: String,
    review_status: [String, Number],
    progress_bar: String,
    tab: String,
    tag: String,
    proctor: Number,
    total_questions: Number,
    homework_data: Object,
    subscription_status: Boolean,
    open_date: String,
  },

  mixins: [clickaway],

  components: {
    StartHomeworkModal: () =>
      import(
        /* webpackChunkName: "StartHomeworkModal" */
        "@/components/modalComps/parentModals/StartHomeworkModal"
      ),
    StartExamModal: () =>
      import(
        /* webpackChunkName: "StartExamModal" */
        "@/components/modalComps/parentModals/StartExamModal"
      ),
    SwitchAccountModal: () =>
      import(
        /* webpackChunkName: "SwitchAccountModal" */
        "@/components/modalComps/parentModals/SwitchAccountModal"
      ),
  },

  computed: {
    hasStarted() {
      let current_date = new Date();
      let open_date = new Date(this.open_date);
      return open_date <= current_date;
    },

    getStatus() {
      if (this.tab !== "Review") return this.status;
      else if (this.tab === "Review" && `${this.review_status}` === "0")
        return "rejected";
      else if (this.tab === "Review" && this.status === "open")
        return "pending";
      else return this.status;
    },

    getStudentAvatar() {
      let avatar = "StudentIcon";
      return `${avatar}${random(2, 1)}.png`;
    },

    getSubmittedStudents() {
      return (this.submitted_students / this.expected_students) * 100;
    },

    studentCount() {
      let style =
        this.submitted_students === 1 || this.submitted_students === 0
          ? "student"
          : "students";
      return `${this.submitted_students}/${this.expected_students} ${style} submitted`;
    },
  },

  watch: {
    progress: "updateProgress",
  },

  created() {
    this.getAccountType();
    this.setupProgress();
  },

  mounted() {
    this.getClassName(this.class_id);
    this.updateStatus();
    this.updateProgress();
    this.setDate();
  },

  data() {
    return {
      account_type: "",
      route_name: "",
      exam_id: "",
      day: "",
      month: "",
      status_color: "",
      class_desc: "",
      homework_option: false,
      progress: 0,
      progress_color: "",

      homework_modal: false,
      exam_modal: false,
      switch_modal: false,
    };
  },

  methods: {
    ...mapActions(["getSingleClass"]),

    handleCardClickActions(event) {
      if (
        event.target.classList.contains("icon-ellipsis-h") ||
        event.target.classList.contains("ignore") ||
        event.target.parentElement.classList.contains("ignore") ||
        event.target.classList.contains("starter-btn") ||
        this.tab === "Draft"
      )
        return true;
      else if (this.tab === "Review") {
        Number(this.total_questions) > 0
          ? this.$emit("view-questions")
          : this.$emit("attach-questions");
      } else if (
        this.account_type === "school" ||
        this.account_type === "teacher"
      ) {
        this.$router.push({
          name: this.route_name,
          params: { homework_id: this.id },
        });
      } else if (this.account_type === "parent") this.toggleSwitchModal();
      else if (
        this.account_type === "student" &&
        (this.tag === "homework" || this.tag === "quiz" || this.tag === null)
      )
        this.toggleHomeworkModal();
      else if (this.account_type === "student" && this.tag === "exam")
        this.toInstructionPage();
    },

    toggleSwitchModal() {
      this.switch_modal = !this.switch_modal;
    },

    getClassName(class_id) {
      if (!class_id) return console.log("[problem found]");
      if (this.account_type === "school") {
        this.getSingleClass(class_id)
          .then((response) => {
            if (response.code === 200)
              this.class_desc = response.data.class_name;
          })
          .catch((err) => console.log(err));
      }
    },

    setupProgress() {
      if (this.progress_bar === "0") this.progress = 0;
      else this.progress = Number([...this.progress_bar].slice(0, -1).join(""));
    },

    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];
      if (this.account_type === "school") this.route_name = "HomeworkReview";
      else if (this.account_type === "teacher") {
        this.route_name = "HomeworkReview_TP";
        this.questions_route_name = "TeacherContentLibrary";
      } else if (this.account_type === "parent")
        this.route_name = "ParentHomeworkTest";
      else if (this.account_type === "student")
        this.route_name = "StudentHomeworkTest";
    },

    updateProgress() {
      if (this.progress >= 75) this.progress_color = "brand_green_bg";
      else if (this.progress >= 45 && this.progress <= 74)
        this.progress_color = "brand_accent_bg";
      else if (this.progress <= 44) this.progress_color = "brand_tonic_bg";
    },

    updateStatus() {
      switch (this.getStatus) {
        case "closed":
          this.status_color = "brand_tonic";
          break;
        case "open":
          this.status_color = "brand_green";
          break;
        case "pending":
          this.status_color = "brand_blue";
          break;
        case "rejected":
          this.status_color = "brand_tonic";
          break;
        default:
          this.status_color = "brand_navy";
      }
    },

    setDate() {
      const date = new Date(this.date.replace(/\s/, "T") + "Z");
      const [month, day] = [date.getMonth(), date.getDate()];
      this.day = day;
      this.month = monthsFormat[month].abbrev;
    },

    toggleHomeworkModal() {
      this.homework_modal = !this.homework_modal;
    },

    toInstructionPage() {
      let in_dev = process.env.NODE_ENV === "development";
      location.href = in_dev
        ? `http://localhost:8096/test/start-exam/${this.id}`
        : `https://app.gradely.ng/test/start-exam/${this.id}`;
    },

    checkIfProctor(event) {
      // console.log(this.proctor);
      if (this.proctor) this.toggleExamModal(event);
      else this.toggleHomeworkModal();
    },

    toggleExamModal(event) {
      this.exam_id = event;
      this.exam_modal = !this.exam_modal;
    },

    toggleHomeworkOption() {
      this.homework_option = !this.homework_option;
    },

    dropOption() {
      this.homework_option = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.homework-card {
  padding: 16px 20px 16px 15px;
  // margin-bottom: 2.5px;
  border-bottom: 2.5px solid #f0f0f0;

  @include breakpoint_max(lg) {
    padding: 12px 16px 12px 11px;
  }

  @include breakpoint_max(xs) {
    padding: 10px 0px;
  }

  .left {
    width: 50%;

    @include breakpoint_max(lg) {
      width: 58%;
    }

    @include breakpoint_max(md) {
      width: 70%;
    }

    @include breakpoint_max(sm) {
      width: 80%;
    }
  }

  .right {
    width: 50%;

    @include breakpoint_max(lg) {
      width: 42%;
    }

    @include breakpoint_max(sm) {
      width: 20%;
    }
  }

  .avatar {
    margin-right: 15px;

    @include breakpoint_max(xl) {
      @include equal_min_edge(42);
    }

    @include breakpoint_max(lg) {
      @include equal_min_edge(42);
      margin-right: 10px;
    }

    @include breakpoint_max(md) {
      @include equal_min_edge(38);
    }

    @include breakpoint_max(sm) {
      margin-right: 10px;
    }

    .avatar-title {
      font-size: 13px;

      @include breakpoint_max(sm) {
        font-size: 12px;
      }

      @include breakpoint_max(xs) {
        font-size: 11.75px;
      }
    }

    .avatar-meta {
      font-size: 10px;

      @include breakpoint_max(sm) {
        margin-top: -2px;
        font-size: 9px;
      }
    }
  }

  .title {
    font-size: 15px;
    line-height: 177.06%;

    @include breakpoint_max(lg) {
      font-size: 14.5px;
    }
    @include breakpoint_max(md) {
      font-size: 14px;
    }

    @include breakpoint_max(sm) {
      font-size: 12.5px;
    }
    @include breakpoint_max(xs) {
      font-size: 11.75px;
    }
  }

  .meta {
    font-size: 12.85px;
    line-height: 18px;

    @include breakpoint_max(md) {
      font-size: 12px;
    }
    @include breakpoint_max(sm) {
      font-size: 11px;
    }
    @include breakpoint_max(xs) {
      font-size: 10px;
    }
  }

  .status {
    @include breakpoint_max(lg) {
      font-size: 12px;
    }
    @include breakpoint_max(sm) {
      font-size: 11px;
    }
    @include breakpoint_max(xs) {
      font-size: 10.5px;
    }
  }

  .progress-container {
    position: relative;

    .progress {
      width: 150px;
      height: 6.5px;
    }

    .submitted_count {
      position: relative;
      top: -6px;
      font-size: 12px;
      line-height: 19px;
    }

    @include breakpoint_max(lg) {
      .progress {
        width: 100px;
      }
    }

    @include breakpoint_max(md) {
      display: none !important;
    }

    .submission_count {
      @include flex_row_center_nowrap;
      .count_text {
        font-size: 14px;
      }
      img {
        @include equal_min_edge(40);
      }
    }
  }

  .option {
    .avatar {
      position: relative;
      left: 16px;

      @include breakpoint_max(xs) {
        left: 8px;
      }
    }
    .dropdown-btn-menu {
      width: 180px;
      margin-bottom: 40px;

      @include breakpoint_max(sm) {
        width: 160px;
      }

      a {
        font-size: 12.5px;

        @include breakpoint_max(sm) {
          padding: 8.75px 8px;
          font-size: 12px;
        }
        @include breakpoint_max(xs) {
          font-size: 11.5px;
        }
      }
    }
  }

  .locked {
    cursor: not-allowed !important;
  }
}
</style>
